var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavoriteIconFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E64646",
  d: "M13.629 2.5A5.371 5.371 0 0 1 19 7.871c0 2.837-1.081 4.275-5.702 7.869l-1.993 1.55a2.125 2.125 0 0 1-2.61 0l-1.993-1.55C2.082 12.146 1 10.708 1 7.87A5.371 5.371 0 0 1 6.371 2.5c1.256 0 2.403.46 3.414 1.346l.215.197.215-.197c1.01-.886 2.158-1.346 3.414-1.346Z"
})));
export { SvgFavoriteIconFilled as ReactComponent };